var blue = '#327db0';
var blueLight = '#6CBDDF';
var blueDark = '#31689a';
var theme = {
  overrides: {
    Main: {
      '@global': {
        a: {
          color: blue
        },
        body: {
          backgroundColor: blue,
          color: '#fff'
        }
      },
      content: {
        backgroundColor: blue,
        paddingTop: 53
      },
      header: {
        border: "8px solid ".concat(blueLight),
        borderTop: 0,
        borderRadius: "0 0 4px 4px",
        margin: '0 8px',
        width: 'calc(100% - 16px)',
        boxShadow: 'none'
      },
      headerToolbar: {
        backgroundColor: '#fff',
        backgroundImage: 'linear-gradient(#d7d7d7 10%, #fff)',
        color: '#000',
        minHeight: 53
      },
      headerText: {
        color: blue
      },
      headerRight: {
        color: blue
      },
      main: {
        border: "8px solid ".concat(blueLight),
        backgroundColor: '#f3f3f3',
        borderRadius: 4,
        margin: "16px 8px 8px 8px"
      }
    },
    Sidebar: {
      menu: {
        backgroundColor: '#e2e3e3',
        borderRadius: 4,
        margin: "16px 0 8px 8px",
        padding: 0,
        boxShadow: 'none',
        '& > $list': {
          padding: 8
        },
        '& > $list > $item > $link': {
          margin: 0
        },
        '&$min > $list': {
          paddingLeft: 8
        },
        '&$min $link': {
          padding: "9px 4px"
        },
        '&$min $submenu': {
          margin: "0 -4px"
        },
        '&$min $toggle': {
          padding: "9px 2px",
          margin: 0
        },
        '&$min $caret': {
          left: 'auto',
          right: 2,
          fontSize: 14
        }
      },
      list: {
        '& $list': {
          paddingLeft: 3,
          paddingRight: 3
        }
      },
      submenu: {
        padding: "8px 4px",
        backgroundImage: 'none'
      },
      item: {
        marginBottom: 6,
        '&:last-child': {
          marginBottom: 0
        },
        '&$hidden': {
          '& $submenu': {
            padding: "0 4px"
          }
        }
      },
      link: {
        borderRadius: 4,
        backgroundImage: "linear-gradient(to bottom, #f2f3f2, #e5e6e5 50%, #e0e0e0 50%, #c3c3c3)",
        boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)",
        minHeight: 37,
        padding: "9px 15px",
        fontSize: 13,
        margin: 0,
        '&$active': {
          backgroundImage: "linear-gradient(to bottom, #a8ecf7, #60d0eb 50%, #3cc5e7 50%, #0093ce)",
          boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)"
        },
        '&:hover': {
          backgroundImage: "linear-gradient(to bottom, #a8ecf7, #60d0eb 50%, #3cc5e7 50%, #0093ce)"
        }
      },
      toggle: {
        borderRadius: 4,
        backgroundImage: "linear-gradient(to bottom, #f2f3f2, #e5e6e5 50%, #e0e0e0 50%, #c3c3c3)",
        boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)",
        minHeight: 37,
        padding: "7px 15px",
        fontSize: 13,
        margin: 0
      },
      caret: {
        position: 'relative',
        right: 0
      },
      label: {
        minWidth: 140
      }
    },
    Login: {
      container: {
        backgroundColor: blue
      },
      form: {
        border: "8px solid ".concat(blueLight),
        backgroundColor: '#f3f3f3',
        borderRadius: 4
      }
    },
    Recovery: {
      container: {
        backgroundColor: blue
      },
      form: {
        border: "8px solid ".concat(blueLight),
        backgroundColor: '#f3f3f3',
        borderRadius: 4
      }
    },
    MuiButton: {
      sizeSmall: {
        padding: '5px 8px'
      },
      root: {
        color: '#4f4f4f',
        borderRadius: 4,
        fontWeight: 400,
        textTransform: 'capitalize',
        letterSpacing: -0.5,
        textShadow: '0 1px 0 #fff',
        boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)",
        lineHeight: 1.25,
        '&disabled': {
          color: '#4f4f4f',
          backgroundImage: "linear-gradient(to bottom, #f5f5f5 50%, #e9e9e9 50%)",
          opacity: 0.65,
          boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)"
        }
      },
      contained: {
        color: '#4f4f4f',
        boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)",
        backgroundImage: "linear-gradient(to bottom, #f5f5f5 50%, #e9e9e9 50%)",
        '&$disabled': {
          color: '#4f4f4f',
          opacity: 0.65,
          boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.5)"
        }
      },
      containedPrimary: {
        color: '#4f4f4f',
        backgroundImage: "linear-gradient(to bottom, #f5f5f5 50%, #e9e9e9 50%)",
        '&:hover': {
          backgroundImage: "linear-gradient(to bottom, #f5f5f5 50%, #f2f2f2 50%)"
        }
      },
      textPrimary: {
        color: '#4f4f4f'
      }
    },
    DangerButton: {
      root: {
        color: '#fff',
        textShadow: '0 -1px 0 rgba(0,0,0,.2)',
        backgroundImage: 'linear-gradient(to bottom, #fc7a7a 50%, #fa4b49 50%)',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'linear-gradient(to bottom,#fa4b49 50%,#c9302d 50%)'
        },
        '&:disabled': {
          color: '#fff'
        }
      }
    },
    WarningButton: {
      root: {
        color: '#fff',
        textShadow: '0 -1px 0 rgba(0,0,0,.2)',
        backgroundImage: 'linear-gradient(to bottom, #f1bf4d 50%, #e2b753 50%)',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'linear-gradient(to bottom,#f1bf4d 50%,#e2b753 50%)'
        },
        '&:disabled': {
          color: '#fff'
        }
      }
    },
    Breadcrumbs: {
      breadcrumbs: {
        padding: 16
      }
    },
    CamiModule: {
      container: {
        padding: 0
      },
      containerFullscreen: {
        padding: 0
      },
      body: {
        padding: 0,
        margin: 0
      },
      buttons: {
        boxShadow: '0 0 30px #f3f3f3',
        backgroundColor: '#f3f3f3',
        marginTop: -41,
        marginBottom: 5,
        paddingRight: 6
      },
      block: {
        marginTop: 16
      },
      subTitle: {
        paddingLeft: 16
      },
      title: {
        paddingLeft: 16,
        marginBottom: 0
      },
      form: {
        margin: 16
      },
      version: {
        paddingLeft: 7
      }
    },
    InventoryModule: {
      container: {
        padding: 0
      },
      containerFullscreen: {
        padding: 0
      },
      body: {
        padding: 0,
        margin: 0
      },
      buttons: {
        boxShadow: '0 0 30px #f3f3f3',
        backgroundColor: '#f3f3f3',
        marginTop: -41,
        marginBottom: 5,
        paddingRight: 6
      },
      block: {
        marginTop: 16
      },
      title: {
        paddingLeft: 16
      },
      subTitle: {
        paddingLeft: 16
      },
      notification: {
        margin: '0 16px'
      },
      form: {
        margin: 16
      },
      version: {
        paddingLeft: 7
      }
    },
    Grid: {
      paper: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: 0,
        borderTop: '8px solid #6CBDDF',
        borderRadius: 0
      },
      selected: {
        color: '#fff',
        backgroundColor: '#6CBDDF !important'
      }
    },
    TableView: {
      paper: {
        borderRadius: 0
      }
    },
    GridView: {
      grid: {
        backgroundColor: '#f3f3f3',
        boxShadow: 'none'
      }
    },
    GridViewToolbar: {
      toolbar: {
        minHeight: 56
      },
      dropdownBootButton: {
        color: blue
      }
    },
    GridViewHeader: {
      cell: {
        backgroundColor: '#f3f3f3'
      }
    },
    GridViewFilter: {
      cell: {
        backgroundColor: '#f3f3f3'
      }
    },
    MuiFormControl: {
      root: {
        marginTop: 20,
        '&:first-child': {
          marginTop: 0
        }
      }
    },
    MuiFormControlLabel: {
      label: {
        color: '#555',
        fontSize: 14
      }
    },
    MuiFormLabel: {
      asterisk: {
        color: '#ff2525',
        fontWeight: 500
      }
    },
    MuiIconButton: {
      root: {
        padding: 8
      }
    },
    MuiPaper: {
      root: {
        backgroundColor: '#f3f3f3'
      },
      elevation1: {
        boxShadow: 'none'
      }
    },
    MuiTypography: {
      h1: {
        fontSize: 20,
        fontWeight: 400,
        marginBottom: 16
      }
    },
    MuiTableRow: {
      root: {
        height: 40,
        '&:nth-child(2n+1)': {
          backgroundColor: 'rgba(52, 124, 176, 0.04)'
        },
        '&$selected': {
          color: '#fff',
          backgroundColor: '#6CBDDF !important'
        }
      }
    },
    MuiTableCell: {
      root: {
        fontSize: 13,
        lineHeight: 1.25
      },
      head: {
        backgroundColor: '#f3f3f3'
      }
    },
    MuiCheckbox: {
      root: {
        padding: '6px 12px'
      }
    },
    MuiInput: {
      underline: {}
    },
    MuiDialog: {
      paper: {
        border: "8px solid ".concat(blueLight),
        borderRadius: 4,
        backgroundColor: '#ededed'
      }
    },
    MuiTabs: {
      root: {
        minHeight: 36,
        borderBottom: '8px solid #6CBDDF'
      },
      flexContainer: {
        paddingTop: 4
      }
    },
    MuiTab: {
      root: {
        padding: '4px 20px',
        border: 0,
        borderRadius: '4px 4px 0 0',
        textTransform: 'capitalize',
        boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.5)',
        backgroundImage: 'linear-gradient(to bottom, #cae9f8, #caeaf9 50%, #b8e6fc 50%, #a4e3fd)',
        marginLeft: 10,
        minHeight: 36,
        minWidth: '0 !important',
        color: '#555',
        fontWeight: 400,
        letterSpacing: 0,
        '&:before': {
          content: '',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: '4px 4px 0 0',
          backgroundImage: 'linear-gradient(to top, #aaaaaa, #d5d5d5)',
          backgroundSize: 'auto 50%'
        },
        '&$selected': {
          // backgroundImage: 'linear-gradient(to top, #6cbddf, #d6edf7)',
          color: '#fff'
        }
      },
      textColorInherit: {
        opacity: 1
      }
    },
    PrivateTabIndicator: {
      root: {
        height: 0
      }
    },
    MuiPickersToolbarButton: {
      toolbarBtn: {
        boxShadow: 'none'
      }
    },
    MonitoringModule: {
      container: {
        padding: 0
      },
      containerFullscreen: {
        padding: 0,
        '& $equipmentGrid': {
          paddingTop: 0
        }
      },
      title: {
        padding: '0 16px'
      },
      subTitle: {
        padding: '0 16px'
      },
      charts: {
        padding: '0 16px'
      },
      chart: {
        border: "4px solid ".concat(blueLight)
      },
      chartLine: {
        border: "4px solid ".concat(blueLight)
      },
      equipmentTable: {
        borderTop: "8px solid ".concat(blueLight),
        borderRadius: 0,
        marginBottom: 0
      },
      equipmentGrid: {
        marginTop: 0
      },
      form: {
        padding: '0 16px'
      },
      bottomCharts: {
        padding: '0 16px 16px'
      },
      devicesServiceCharts: {
        paddingBottom: 16
      },
      reportsGrid: {
        '& > div': {
          borderTop: '1px solid rgba(224, 224, 224, 1)'
        }
      },
      reportsGridBlock: {
        borderTop: "8px solid ".concat(blueLight),
        paddingTop: 12
      },
      version: {
        paddingLeft: 7
      }
    },
    DateBetween: {
      toggle: {
        color: '#212121'
      },
      toggleLabel: {
        backgroundColor: '#f3f3f3'
      },
      datepickerTd: {
        borderColor: '#f3f3f3'
      },
      otherDay: {
        borderColor: '#f3f3f3'
      },
      highlight: {
        backgroundColor: 'rgba(108, 189, 223, 0.5)'
      },
      highlightStart: {
        backgroundColor: 'rgba(108, 189, 223, 0.5)',
        '& > button': {
          backgroundColor: blueLight
        }
      },
      highlightEnd: {
        backgroundColor: 'rgba(108, 189, 223, 0.5)',
        '& > button': {
          backgroundColor: blueLight
        }
      }
    },
    FastFilter: {
      filter: {
        borderTop: "8px solid ".concat(blueLight),
        borderRadius: 0,
        marginTop: 0
      },
      yellowButton: {
        color: '#fff',
        textShadow: '0 -1px 0 rgba(0,0,0,.2)',
        backgroundImage: 'linear-gradient(to bottom, #f1bf4d 50%, #e2b753 50%)',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'linear-gradient(to bottom,#f1bf4d 50%,#e2b753 50%)'
        },
        '&:disabled': {
          color: '#fff'
        },
        '&$active': {
          backgroundImage: 'linear-gradient(to bottom, #ff6e20 50%, #ff5a00 50%)'
        }
      },
      greenButton: {
        color: '#fff',
        textShadow: '0 -1px 0 rgba(0,0,0,.2)',
        backgroundImage: 'linear-gradient(to bottom, #a8ecf7, #60d0eb 50%, #3cc5e7 50%, #0093ce);',
        '&:hover': {
          color: '#fff',
          backgroundImage: 'linear-gradient(to bottom, #a8ecf7, #60d0eb 50%, #3cc5e7 50%, #0093ce);'
        },
        '&:disabled': {
          color: '#fff'
        },
        '&$active': {
          backgroundImage: 'linear-gradient(to bottom, #ff6e20 50%, #ff5a00 50%)'
        }
      }
    },
    DevicesLoadingCount: {
      chart: {
        border: "4px solid ".concat(blueLight)
      }
    },
    DevicesLoadingChartCounter: {
      chartContainer: {
        border: "4px solid ".concat(blueLight),
        marginTop: 8
      }
    },
    DevicesLoadingChartNumbers: {
      chartContainer: {
        border: "4px solid ".concat(blueLight)
      }
    },
    DevicesLoadingChartAverage: {
      chartContainer: {
        border: "4px solid ".concat(blueLight)
      }
    },
    QuoteChart: {
      chart: {
        border: "4px solid ".concat(blueLight)
      }
    },
    LoadsRegionalCount: {
      chart: {
        border: "4px solid ".concat(blueLight),
        height: 192
      }
    },
    LoadsRegionalChart: {
      chart: {
        border: "4px solid ".concat(blueLight),
        margin: '0 16px 16px'
      }
    },
    Select: {
      paper: {
        border: "2px solid ".concat(blue),
        borderRadius: 4
      }
    }
  },
  palette: {
    background: {
      default: blue,
      paper: '#fbfbfd'
    },
    primary: {
      contrastText: '#fff',
      dark: blueDark,
      light: blueLight,
      main: blue
    },
    secondary: {
      contrastText: '#fff',
      dark: '#212121',
      light: '#9E9E9E',
      main: '#616161'
    }
  },
  typography: {
    htmlFontSize: 16
  }
};
export default theme;